import { render, staticRenderFns } from "./IframeBox.vue?vue&type=template&id=693a73cc&scoped=true&"
import script from "./IframeBox.vue?vue&type=script&lang=js&"
export * from "./IframeBox.vue?vue&type=script&lang=js&"
import style0 from "./IframeBox.vue?vue&type=style&index=0&id=693a73cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a73cc",
  null
  
)

export default component.exports